var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../config/request';
export const fetchSYear = createAsyncThunk('syaer/fetch', (_, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data } = yield request('/selectors/syears', 'POST');
        // const filterYear: IYears[] = data.filter(item => item.defaultValue == 1)
        return data;
    }
    catch (e) {
        return thunkAPI.rejectWithValue('Ошибка');
    }
}));
